// mesbot/src/institution/InstitutionApp.js
import React, { useState } from "react";
import InstitutionLogin from "./InstitutionLogin";
import InstitutionLayout from "./InstitutionLayout";
import "./Institution.css";

const TOKEN_KEY = "inst_token";
const USER_KEY = "inst_user";

export default function InstitutionApp() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem(USER_KEY)); }
    catch { return null; }
  });
  const [activePage, setActivePage] = useState("overview");

  function handleLogin(data) {
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(USER_KEY, JSON.stringify({
      role: data.role,
      institutionName: data.institution_name,
    }));
    setToken(data.access_token);
    setUser({ role: data.role, institutionName: data.institution_name });
    setActivePage("overview");
  }

  function handleLogout() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    setToken(null);
    setUser(null);
  }

  if (!token || !user) {
    return <InstitutionLogin onLogin={handleLogin} />;
  }

  return (
    <InstitutionLayout
      token={token}
      user={user}
      activePage={activePage}
      setActivePage={setActivePage}
      onLogout={handleLogout}
    />
  );
}
